import Vue from 'vue'
import Router from 'vue-router'
// import RouteView from '@/layouts/RouteView'

Vue.use(Router)
export default new Router({
  routes: [
    {
      path: '/login',
      name: 'Login',
      component: () => import('@/pages/login/Login'),
      invisible: true
    },
    {
      path: '/resultado_externo',
      name: 'Resultado Externo',
      component: () => import('@/pages/resultado/Resultado'),
      invisible: true
    },
    {
      path: '/recuperar_clave',
      name: 'Recuperar Clave',
      component: () => import('@/pages/recuperarPassword/Recuperar'),
      invisible: true
    },
    {
      path: '/restaurar_clave',
      name: 'Restaurar Clave',
      component: () => import('@/pages/restaurarPassword/Restaurar'),
      invisible: true
    },
    {
      path: '/registro',
      name: 'Registro',
      component: () => import('@/pages/registro/Registro'),
      invisible: true
    },
    {
      path: '/',
      name: 'Home',
      component: () => import('@/layouts/MenuView'),
      redirect: '/login',
      icon: 'none',
      invisible: true,
      children: [
        {
          path: '/inicio',
          name: 'Inicio',
          component: () => import('@/pages/inicio/Inicio'),
          icon: 'home',
          authority: ['ADMINISTRADOR', 'SUPERADMINISTRADOR', 'CLIENTE']
        },
        {
          path: '/comprarCartonesOpciones/',
          name: 'Comprar Cartones',
          component: () => import('@/pages/cartones/comprarCartonesOpciones'),
          invisible: false,
          icon: 'table',
          authority: ['ADMINISTRADOR', 'SUPERADMINISTRADOR', 'CLIENTE']
        },
        {
          path: '/comprarCartones/:cantidad',
          name: 'Comprar Cartones Principal',
          component: () => import('@/pages/cartones/comprarCartonesOpciones'), // Cambio para que no puedan comprar por mp
          invisible: true,
          authority: ['ADMINISTRADOR', 'SUPERADMINISTRADOR', 'CLIENTE']
        },
        {
          path: '/comprarCartonesFD/:cantidad',
          name: 'Comprar Cartones Principal',
          component: () => import('@/pages/cartones/ComprarCartonesFD'),
          invisible: true,
          authority: ['ADMINISTRADOR', 'SUPERADMINISTRADOR', 'CLIENTE']
        },
        {
          path: '/comprarCartonesPEI/:cantidad',
          name: 'Comprar Cartones Principal',
          component: () => import('@/pages/cartones/ComprarCartonesPEI'),
          invisible: true,
          authority: ['ADMINISTRADOR', 'SUPERADMINISTRADOR', 'CLIENTE']
        },
        {
          path: '/misCartones',
          name: 'Mis Cartones',
          component: () => import('@/pages/cartones/MisCartones'),
          invisible: false,
          icon: 'bars',
          authority: ['ADMINISTRADOR', 'SUPERADMINISTRADOR', 'CLIENTE']
        },
        {
          path: '/ruleta',
          name: 'Jugá a la Ruleta',
          component: () => import('@/pages/ruleta/Ruleta'),
          invisible: true,
          icon: 'caret-right',
          authority: ['ADMINISTRADOR', 'SUPERADMINISTRADOR']
        },
        {
          path: '/ruletaJuego',
          name: 'JUEGO',
          component: () => import('@/pages/ruleta/RuletaJuego'),
          invisible: true,
          icon: 'caret-right',
          authority: ['ADMINISTRADOR', 'SUPERADMINISTRADOR']
        },
        {
          path: '/comprarCreditosOpciones/',
          name: 'Comprar Creditos',
          component: () => import('@/pages/creditos/comprarCreditosOpciones'),
          invisible: false,
          icon: 'dollar',
          authority: ['ADMINISTRADOR', 'SUPERADMINISTRADOR', 'CLIENTE']
        },
        // {
        //   path: '/gateway',
        //   name: 'Gateway',
        //   component: () => import('@/pages/gateway/Pagar'),
        //   invisible: true,
        //   icon: 'dollar',
        //   authority: ['ADMINISTRADOR', 'SUPERADMINISTRADOR', 'CLIENTE']
        // },
        {
          path: '/comprarCreditos/:cantidad',
          name: 'Comprar Creditos Principal',
          component: () => import('@/pages/creditos/comprarCreditosOpciones'), // Cambio para que no puedan comprar por mp
          invisible: true,
          icon: 'dollar',
          authority: ['ADMINISTRADOR', 'SUPERADMINISTRADOR', 'CLIENTE']
        },
        {
          path: '/comprarCreditosFD/:cantidad',
          name: 'Comprar Creditos Principal',
          component: () => import('@/pages/creditos/ComprarCreditosFD'),
          invisible: true,
          icon: 'dollar',
          authority: ['ADMINISTRADOR', 'SUPERADMINISTRADOR', 'CLIENTE']
        },
        {
          path: '/comprarCreditosPEI/:cantidad',
          name: 'Comprar Creditos Principal',
          component: () => import('@/pages/creditos/ComprarCreditosPEI'),
          invisible: true,
          icon: 'dollar',
          authority: ['ADMINISTRADOR', 'SUPERADMINISTRADOR', 'CLIENTE']
        },
        {
          path: '/usarCreditos/:cantidad',
          name: 'Usar Creditos',
          component: () => import('@/pages/creditos/UsarCreditos'),
          invisible: true,
          icon: 'dollar',
          authority: ['ADMINISTRADOR', 'SUPERADMINISTRADOR', 'CLIENTE']
        },
        {
          path: '/cartonesGratis',
          name: 'Cartones Gratis',
          component: () => import('@/pages/creditos/CartonesGratis'),
          invisible: true,
          icon: 'tags',
          authority: ['ADMINISTRADOR', 'SUPERADMINISTRADOR', 'CLIENTE']
        },
        {
          path: '/retirarCreditos',
          name: 'Retirar Creditos',
          component: () => import('@/pages/creditos/RetirarCreditos'),
          invisible: false,
          icon: 'export',
          authority: ['ADMINISTRADOR', 'SUPERADMINISTRADOR', 'CLIENTE']
        },
        {
          path: '/jugarEnVivo',
          name: 'Jugar En Vivo',
          component: () => import('@/pages/vivo/Jugar'),
          invisible: false,
          icon: 'video-camera',
          authority: ['ADMINISTRADOR', 'SUPERADMINISTRADOR', 'CLIENTE']
        },
        {
          path: '/resultado',
          name: 'Resultado',
          component: () => import('@/pages/resultado/Resultado'),
          invisible: true,
          authority: ['ADMINISTRADOR', 'SUPERADMINISTRADOR', 'CLIENTE']
        },
        {
          path: '/reglamento',
          name: 'Reglamento',
          icon: 'read',
          component: () => import('@/pages/reglamento/Reglamento'),
          authority: ['ADMINISTRADOR', 'SUPERADMINISTRADOR', 'CLIENTE']
        },
        {
          path: '/sugerencias',
          name: 'Libro de Sugerencias',
          icon: 'read',
          component: () => import('@/pages/sugerencias/Sugerencias'),
          authority: ['ADMINISTRADOR', 'SUPERADMINISTRADOR', 'CLIENTE']
        },
        {
          path: '/comprarCreditosTransferencia',
          name: 'Compra de Creditos por Transferencia',
          invisible: true,
          icon: 'read',
          component: () =>
            import('@/pages/creditos/ComprarCreditosTransferencia'),
          authority: ['ADMINISTRADOR', 'SUPERADMINISTRADOR', 'CLIENTE']
        },
        {
          path: '/pagoPresencial',
          name: 'Pago Presencial',
          invisible: true,
          icon: 'read',
          component: () => import('@/pages/creditos/PagoPresencial'),
          authority: ['ADMINISTRADOR', 'SUPERADMINISTRADOR', 'CLIENTE']
        },
        {
          path: '/cerrar_sesion',
          name: 'Cerrar Sesion',
          icon: 'logout',
          component: () => import('@/pages/inicio/CerrarSesion'),
          authority: ['ADMINISTRADOR', 'SUPERADMINISTRADOR', 'CLIENTE']
        }
      ]
    }
  ],
  scrollBehavior () {
    return { x: 0, y: 0 }
  }
})



// WEBPACK FOOTER //
// ./src/router/lazy.js